<template>
  <div class="container">
    <content-header :data="[{text: '试题', path: '/question/list'},{text:(curObj.id ? '修改':'添加')+'试题', path: ''}]"></content-header>
    <div class="content">
      <el-form :model="curObj" label-position="right" label-width="0px">
        <el-form-item prop="type" label="题型" :label-width="formLabelWidth">
          <el-select v-model="curObj.type" clearable value-key="id" placeholder="请选择题型">
            <el-option
              v-for="item in typeIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="categoryId" label="分类" :label-width="formLabelWidth">
          <el-select v-model="curObj.categoryId" clearable value-key="id" placeholder="请选择分类">
            <el-option
              v-for="item in categoryIds"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="question" label="试题内容" :label-width="formLabelWidth">
          <ky-editor v-model="curObj.question"
            ref="myQuillEditor">
          </ky-editor>
        </el-form-item>
        <el-form-item prop="options" v-for="(item, index) in curObj.options" :key="item.optionName" :label="'选项' + item.optionName " :label-width="formLabelWidth">
          <ky-editor v-model="item.optionValue"
            ref="myQuillEditor">
          </ky-editor>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-button icon="el-icon-plus" @click="addOption">添加选项</el-button>
          <el-button icon="el-icon-delete" @click="removeOption" v-if="curObj.options.length > 1">删除选项</el-button>
        </el-form-item>
        <el-form-item prop="answer" label="答案" :label-width="formLabelWidth">
          <div><button v-for="item in curObj.options" :key="item.optionName" :class="{ 'active': isAnswer(item.optionName) }" @click="checkAnswer(item.optionName)" class="answer-chart">{{ item.optionName }}</button></div>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-button type="primary" @click="confirmHandle">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/babel">
  import QuestionModel from 'models/question'
  import KyEditor from 'components/KyEditor'

  export default {
    components: {
      KyEditor,
    },
    data () {
      return {
        optionNames: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
        categoryIds: [],
        typeIds: [{id: 1, name: '单选题'}, {id: 2, name: '多选题'}],
        curObj: {
          id: '',
          question: '',
          type: 1,
          categoryId: '',
          options: [
            {
              optionName: 'A',
              optionValue: '',
              isAnswer: false
            }, {
              optionName: 'B',
              optionValue: '',
              isAnswer: false
            }, {
              optionName: 'C',
              optionValue: '',
              isAnswer: false
            }, {
              optionName: 'D',
              optionValue: '',
              isAnswer: false
            }
          ]
        },
        formLabelWidth: '80px'
      }
    },
    created () {
      //
      this.curObj.id = this.$route.query.id
      console.log(this.curObj.id)
      if (this.curObj.id) {
        QuestionModel.get({
          id: this.curObj.id
        }).then(res => {
          this.curObj = res
          console.log(this.curObj)
        })
      }
      QuestionModel.findCategory({curPage: 1, pageSize: 1000}).then(res => {
        this.categoryIds = res.item_list
      })
    },
    methods: {
      confirmHandle () {
        if (this.notValid()) return
        if (this.curObj.id) return this.editHandle()
        this.newHandle()
      },
      notValid () {
        // 校验选择题的所有选项
        let noEmptyOption = !this.curObj.options.some(item => item.optionValue === '')
        let hasAnswer = this.curObj.options.some(item => item.isAnswer === true)
        // 校验对象及输出的MAP
        const UNIT_PASS = [{
          bool: this.curObj.type,
          msg: '请选择题型'
        }, {
          bool: this.curObj.categoryId,
          msg: '请选择分类'
        }, {
          bool: this.curObj.question,
          msg: '请输入试题内容'
        }, {
          bool: noEmptyOption,
          msg: '请输入每个选项的内容'
        }, {
          bool: hasAnswer,
          msg: '请选择答案'
        }]
        // 返回true是找到一个不符的
        return UNIT_PASS.some(item => {
          if (!item.bool) {
            this.$message({ message: item.msg, type: 'error' })
            return true
          }
        })
      },
      newHandle () {
        QuestionModel.create(this.curObj).then(() => {
          this.$router.push({ name: 'question.list' })
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      editHandle () {
        QuestionModel.update(this.curObj).then(() => {
          this.$message({ message: '更新成功', type: 'success' })
          this.$router.push({ name: 'question.list' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      isAnswer (name) {
        return this.curObj.options.find(item => item.optionName === name).isAnswer
      },
      checkAnswer (name) {
        for (let i = 0; i < this.curObj.options.length; i++) {
          if (this.curObj.options[i].optionName === name) {
            this.curObj.options[i].isAnswer = !this.curObj.options[i].isAnswer
          } else if (this.curObj.type === 1) {
            this.curObj.options[i].isAnswer = false
          }
        }
      },
      addOption () {
        // find next option name
        let item = this.curObj.options[this.curObj.options.length - 1]
        let nextItem = {
          optionName: '',
          optionValue: '',
          isAnswer: false
        }
        for (let i = 0; i < this.optionNames.length; i++) {
          if (item.optionName === this.optionNames[i]) {
            if (i < this.optionNames.length - 1) {
              nextItem.optionName = this.optionNames[i + 1]
              break
            } else {
              this.$message.error('选择题选项不能多于10个')
              return
            }
          }
        }
        this.curObj.options.push(nextItem)
      },
      removeOption () {
        if (this.curObj.options.length > 2) {
          this.curObj.options.pop()
        } else {
          this.$message.error('选择题至少要有两个选项')
        }
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    padding: 20px
    font-size: 14px
    .el-input
      width: 50%
    .textarea
      width: 80%
    .avatar-uploader
        border: 1px dashed #d9d9d9
        border-radius: 6px
        cursor: pointer
        position: relative
        overflow: hidden
        width: 180px
        &:hover
          border-color: #409EFF
        .avatar-uploader-icon
          font-size: 28px
          color: #8c939d
          width: 178px
          height: 178px
          line-height: 178px
          text-align: center
        .avatar
          width: 178px
          height: 178px
          display: block
    .answer-chart
      display: inline-block
      line-height: 1
      white-space: nowrap
      cursor: pointer
      background: #fff
      border: 1px solid #bfcbd9
      color: #1f2d3d
      margin: 0
      padding: 10px 15px
      border-radius: 4px
      + .answer-chart
        margin-left: 10px
      &.active
        border-color: #4db3ff
        color: #4db3ff
</style>



// WEBPACK FOOTER //
// src/views/QuestionNew.vue